import {
  IssueAttributes,
  IssueCustomAttribute,
  IssueStatus,
  IssueTemplate,
  IssueTemplateIssueAttributes,
} from "@adsk/acc-issues-types";
import { getDateFormatToDays } from "@adsk/acc-issues-common/utils/date/dateUtils";
import pick from "lodash/pick";
import {
  IssueFormAttributes,
  CustomAttributesInForm,
} from "@adsk/acc-issues-core/utils/types/Issue";

export const getIssueAttributesFromTemplateIssueAttributes = (
  templateIssueAttributes: IssueTemplateIssueAttributes
): IssueAttributes => {
  const keysInCommon: (keyof IssueAttributes)[] = [
    "title",
    "description",
    "status",
    "rootCauseId",
    "locationId",
    "locationDetails",
    "assignedToType",
    "watchers",
    "watcherObjects",
    "customAttributes",
  ];
  const issueAttributesInCommon: Partial<IssueAttributes> = pick(
    templateIssueAttributes,
    keysInCommon
  );
  const issueAttributes: IssueAttributes = {
    // title will always be provided, so just use an empty string to make ts happy
    title: "",
    // custom attributes should be provided, but we want an empty object if not
    customAttributes: [],
    // default to Open if no status provided
    status: IssueStatus.Open,
    issueTypeId: templateIssueAttributes.typeId,
    published: true,
    ...issueAttributesInCommon,
  };
  if (templateIssueAttributes.assigneeId) {
    issueAttributes.assignedTo = templateIssueAttributes.assigneeId;
  }
  if (Number.isInteger(templateIssueAttributes.daysTilDueDate)) {
    issueAttributes.dueDate = getDateFormatToDays(
      new Date(
        new Date().getTime() +
          1000 /* ms */ *
            60 /* s */ *
            60 /* min */ *
            24 /* hr */ *
            templateIssueAttributes.daysTilDueDate!
      )
    );
  }
  return issueAttributes;
};

export const getIssueAttributesFromTemplate = (
  issueTemplate: IssueTemplate
) => {
  return getIssueAttributesFromTemplateIssueAttributes(
    issueTemplate.issueAttributes
  );
};

export const getIssueFormAttributesFromTemplate = (
  issueTemplate: IssueTemplate
): IssueFormAttributes => {
  const issueAttributes = getIssueAttributesFromTemplate(issueTemplate);
  const customAttributes: CustomAttributesInForm = {};
  if (issueAttributes.customAttributes?.length) {
    issueAttributes.customAttributes.forEach(
      (customAttr: IssueCustomAttribute) => {
        customAttributes[customAttr.attributeDefinitionId] = customAttr.value;
      }
    );
  }
  const issueFormAttributes: IssueFormAttributes = {
    ...issueAttributes,
    customAttributes,
  };

  return issueFormAttributes;
};
